import { USER_ROLES } from '../../shared/security/RolesAllowed';

export const settingsSections = [
	{
		section: 'countries',
		label: 'Countries',
		icon: 'fas fa-flag',
		rolesAllowed: [USER_ROLES.ADMIN]
	},
	{
		section: 'technologies',
		label: 'Technologies',
		icon: 'fas fa-clipboard-list',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'tags',
		label: 'Tags',
		icon: 'fas fa-tag',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'job-roles',
		label: 'Job Roles',
		icon: 'fas fa-user-tag',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'industries',
		label: 'Industries',
		icon: 'fas fa-industry',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'expertise-areas',
		label: 'Expertise Areas',
		icon: 'fas fa-flask',
		rolesAllowed: [USER_ROLES.ADMIN]
	},
	{
		section: 'recruiters',
		label: 'Recruiters',
		icon: 'fas fa-user-friends',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'currencies',
		label: 'Currencies',
		icon: 'fas fa-dollar-sign',
		rolesAllowed: [USER_ROLES.ADMIN]
	},
	{
		section: 'test-results-files',
		label: 'Test Results Files',
		icon: 'fas fa-table',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'locations',
		label: 'Locations',
		icon: 'fas fa-location-dot',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	},
	{
		section: 'users',
		label: 'Users',
		icon: 'fas fa-users',
		rolesAllowed: [USER_ROLES.ADMIN]
	},
	{
		section: 'scorecard-templates',
		label: 'Scorecard Templates',
		icon: 'fas fa-clipboard-check',
		rolesAllowed: [USER_ROLES.ADMIN]
	},
	{
		section: 'tests',
		label: 'Tests',
		icon: 'fas fa-vial',
		rolesAllowed: [USER_ROLES.ADMIN, USER_ROLES.MANAGER]
	}
];

export function getSettingsSectionLabel(section) {
	const match = settingsSections.find(item => item.section === section);
	return match?.label || section.replace(/-/g, ' ');
}
